class DesignerFileMenu {

  constructor(config) {
    this.app = config.app;


    safeAddListener("file_new", "click", (event) => {
      if (confirm("Start a New Design ?")) {
        //this.app.signals.designNew.dispatch();
        this.newDesign();
        document.querySelector(".boardImage[title='Baltic Birch Plywood - 15x15 Square']").click();
      }
    });

    safeAddListener("file_save", "click", () => this.saveDesign());
    safeAddListener("file_download", "click", () => this.downloadCurrentDesign());
    safeAddListener("file_load", "click", () => this.loadDesign());
    safeAddListener("file_import", "click", () => {
      const fileInput = document.getElementById("jsonFileInput");
      if (fileInput) {
        fileInput.click();
      }
    });
    safeAddListener("file_capture", "click", () => this.saveDesignAsImage());
    safeAddListener("file_designs", "click", () => {
      const dialog = document.getElementById("designsDialog");
      if (dialog) {
        dialog.showModal();
      }
    });
    
    const setupFileInput = () => {
      const fileInput = document.getElementById("jsonFileInput");
      if (fileInput) {
        fileInput.addEventListener("change", (event) => this.processUploadedJsonFile(event));
      }
    };
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", setupFileInput);
    } else {
      setupFileInput();
    }


    safeAddListener("selectSavedDesign", "change", () => this.selectSaveDesign());
    safeAddListener("loadSavedDesign", "click", () => this.loadSavedDesign());
    safeAddListener("downloadSavedDesign", "click", () => this.fileDownloadDesign());
    safeAddListener("deleteSavedDesign", "click", () => this.deleteSavedDesign());

  }


  newDesign() {
    this.app.deleteAllNodes();
    this.app.setDesignName("untitled");
    this.app.selectNone();
  }

    
  saveDesign() {
    //console.log("file menu saveDesign");
    let filename = prompt("Save as", this.app.getDesignName());

    if (filename) {
      this.app.setDesignName(filename);

      if (this.doesDesignExist("customizer-" + this.app.getDesignName())) {
        if (!confirm("A design with that name already exists. Okay to overwrite it?")) {
          return;
        }
      }

      //console.log("Save as JSON", layer.toJSON());
      let layerJson = JSON.parse(this.app.getLayer().toJSON());
      //console.log("Save as JSON.parse", layerJson);
      layerJson.name = this.app.getDesignName();
      layerJson.image = trimCanvas().toDataURL({ pixelRatio: 2 });

      thumbRunner(layerJson).then(function (resizedImageDataURI) {
        //console.log(resizedImageDataURI);
      });
    }
  }


  downloadString(filename, text, type = 'text/json') {
    // Create a Blob from the text content with the specified MIME type
    const blob = new Blob([text], { type: type });
    
    // Create an invisible anchor element
    const a = document.createElement('a');
    a.style.display = 'none';
    document.body.appendChild(a);

    // Set the href to a Blob URL
    a.href = window.URL.createObjectURL(blob);
    
    // Use the download attribute to set the desired file name and force download
    a.setAttribute('download', filename);

    // Trigger the download by simulating a click
    a.click();

    // Clean up by revoking the object URL and removing the element
    window.URL.revokeObjectURL(a.href);
    document.body.removeChild(a);
  }


  loadDesign() {
    //console.log("file menu loadDesign");
    //document.getElementById("jsonFileInput").click();
    let saveDesigns = this.getLocalStorageDesigns();
    //console.log(saveDesigns);

    let selList = document.getElementById("selectSavedDesign");
    selList.length = 0;

    if (saveDesigns.length > 0) {
      saveDesigns.forEach((design) => {
        let newOption = new Option(design.replace('customizer-', ''), design);
        newOption.setAttribute("data-img", this.getLocalDesignThumbnail(design));
        selList.add(newOption);
      });

      let ssd = document.getElementById("selectSavedDesign");
      const changeEvent = new Event('change', { bubbles: true });
      ssd.dispatchEvent(changeEvent);

      document.getElementById("loadDialog").showModal();
    } else {
      showMessage("Notice", "No saved designs found.");
    }
  }


  loadSavedDesign() {
    //console.log("file menu loadSavedDesign");
    let loadButton = document.getElementById("loadSavedDesign");
    let selList = document.getElementById("selectSavedDesign");
    let selIndex = selList.selectedIndex;

    if (selIndex >= 0) {
      document.getElementById("loadDialog").close();
      let selectedText = selList.options[selIndex].value;
      this.loadDesignFromLocalStorage(selectedText);
      this.app.setDesignName(selectedText.replace('customizer-', ''));
    }
  }


  selectSaveDesign() {
    //console.log("file menu selectSaveDesign");
    
    let selList = document.getElementById("selectSavedDesign");
    let selImage = document.getElementById("selectSavedDesignImage");
    let selIndex = selList.selectedIndex;

    if (selIndex >= 0) {
      let selectedImage = selList.options[selIndex].getAttribute("data-img");
      selImage.src = selectedImage;
    }
  }


  deleteSavedDesign() {
    //console.log("file menu deleteSavedDesign");
    let loadButton = document.getElementById("loadSavedDesign");
    let selList = document.getElementById("selectSavedDesign");
    let selIndex = selList.selectedIndex;

    if (selIndex >= 0) {
      if (confirm("Are you sure want to delete this saved design?")) {
        let selectedText = selList.options[selIndex].value;
        this.deleteLocalStorageDesign(selectedText);
        document.getElementById("loadDialog").close();
      }
    }
  }
  

  processUploadedJsonFile(event) {
    //console.log("jsonFileInput");

    const file = event.target.files[0]; // Get the selected file
    if (!file) {
      console.error("No file uploaded");
      return;
    }

    // Check if the file type is JSON (optional, but good practice)
    if (file.type !== "application/json" && file.type !== "application/pdf") {
      console.error("not a valid file type");
      return;
    }

    const reader = new FileReader();

    // What to do when the file is successfully read
    reader.onload = (e) => {
      const fileContents = e.target.result;

      try {
        const parsedJson = JSON.parse(fileContents);
        layerFromJSON(parsedJson);
      } catch (error) {
        console.error("Error parsing JSON:", error);
      }

      document.getElementById("jsonFileInput").value = "";
    };

    // What to do if an error occurs during reading
    reader.onerror = (e) => {
      console.error("FileReader error:", reader.error);
    };

    // Read the file as text
    reader.readAsText(file);
  }

  
  deleteLocalStorageDesign(name) {
    localStorage.removeItem(name);
  }


  loadPrebuiltDesign(title) {
    //console.log("file menu loadPrebuiltDesign");

    design_files.forEach((obj) => {
      //console.log("loadPrebuiltDesign Checking", obj.title.toLowerCase().trim(), " / ", title.toLowerCase().trim());
      if (obj.title.toLowerCase().trim() == title.toLowerCase().trim()) {
        this.app.selectNode(null);
        this.newDesign();

        let json = JSON.parse(obj.design_data);
        layerFromJSON(json);
      }
    });
  }


  getAllLocalStorageKeys() {
    const keys = [];

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      keys.push(key);
    }

    return keys;
  }


  getLocalStorageDesigns() {
    const keys = [];

    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key.includes(this.app.getDesignNamePrefix())) {
        keys.push(key);
      }
    }

    return keys;
  }


  saveDesignToLocalStorage(name, data) {
    localStorage.setItem(name, data);
  }


  loadDesignFromLocalStorage(name) {
    this.app.deleteAllNodes();
    layerFromJSON(this.localDesignToJSON(localStorage.getItem(name)));
  }


  loadDesignJSON(name) {
    return this.localDesignToJSON(localStorage.getItem(name));
  }


  doesDesignExist(name) {
    return localStorage.getItem(name) != null;
  }


  getLocalDesignThumbnail(name) {
    let designJson = this.localDesignToJSON(localStorage.getItem(name));
    return designJson.image;
  }


  localDesignToJSON(data) {
    const dataURI = decodeURIComponent(data);

    //const dataURI = "data:application/json;base64,ew0KICAgICJtYWx0X3R5cGUiOiAibG9nIiwNCiAgICAibWFsdF9kYXRhIjogIldvdywgdSByIGFsbW9zdCB0aGVyZSA6TyINCn0=";

    // 1. Extract the Base64 encoded data
    //const base64Data = dataURI.split(',')[1];
    const base64Data = dataURI.replace("data:text/json;charset=utf-8,", "");
    //console.log("base64Data");
    //console.log(base64Data);

    // 2. Decode the Base64 data
    //const decodedString = atob(base64Data); // 'atob' decodes Base64

    // 3. Parse the JSON string
    try {
      const jsonObject = JSON.parse(base64Data);
      //console.log(jsonObject);
      return jsonObject;
    } catch (error) {
      console.error("Error parsing JSON:", error);
    }

  }


  saveCurrentDesign() {
    let layerJson = this.app.getLayer().toJSON();
    var dataStr = "data:text/json;charset=utf-8," + encodeURIComponent(layerJson);
    this.saveDesignToLocalStorage("currentcustomizerdesign", dataStr);
  }


  saveDesignAsImage() {
    let filename = prompt("Save as", this.app.getDesignName());

    if (filename) {
      this.app.setDesignName(filename);

      //console.log("saveDesignAsImage");
      //console.log(this.app.getBaseImageTransformer());
      //console.log(this.app.getTransformer());

      this.app.getBaseImageTransformer().hide();
      this.app.getTransformer().hide();

      /*
      const dataURL = this.app.getStage().toDataURL({
        pixelRatio: 2, // double resolution
      });
      */

      let ratio = 2;
      if (this.app.getStage().width() < 768) {
        ratio = 5;
      }

      /*
      const dataURL = trimCanvas().toDataURL({
        pixelRatio: ratio, // double resolution
      });
      */
      let dataURL = this.app.getStage().toDataURL({
        pixelRatio: ratio, // Adjust this value for higher resolution
        mimeType: 'image/png'
      });
      dataURL = removeTransparentBorders(dataURL, filename);
      /*
      console.log("dataURL", dataURL);

      console.log("Ratio", ratio);

      // create link to download
      const link = document.createElement("a");
      link.download = filename + ".png";
      link.href = dataURL;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      */

      this.app.getBaseImageTransformer().show();
      this.app.getTransformer().show();
    }
  };


  fileDownloadDesign() {
    let loadButton = document.getElementById("loadSavedDesign");
    let selList = document.getElementById("selectSavedDesign");
    let selIndex = selList.selectedIndex;
    let filename = null;

    if (selIndex >= 0) {
      document.getElementById("loadDialog").close();
      let selectedText = selList.options[selIndex].value;
      filename = selectedText;
    }

    if (filename) {
      let layerJson = this.loadDesignJSON(filename);
      console.log("fileDownloadDesign JSON", JSON.stringify(layerJson));
      let dataStr = "data:text/json;charset=utf-8," + JSON.stringify(layerJson);
      console.log("fileDownloadDesign dataStr", dataStr);
      
      var dlAnchorElem = document.getElementById("downloadAnchorElem");
      dlAnchorElem.setAttribute("href", dataStr);
      dlAnchorElem.setAttribute("download", filename + ".json");
      dlAnchorElem.click();
    }
  }



  downloadCurrentDesign() {
    let filename = prompt("Save as", this.app.getDesignName());

    if (filename) {
      this.downloadDesignAsJson(this.app.getLayer(), filename);
    }
  }



  /**
   * Serializes a Konva Stage to JSON and triggers a browser download
   * @param {Konva.Stage} stage - Your Konva stage instance
   * @param {string} [filename="konva-stage.json"] - Desired download filename
   * @param {object} [options] - Optional settings
   * @param {number} [options.space=2] - JSON indentation (null = compact)
   */
  downloadDesignAsJson(layer, filename = "konva-stage.json", options = {}) {
    if (!layer || !(layer instanceof Konva.Layer)) {
      console.error("downloadDesignAsJson: valid Konva.Layer instance required");
      return false;
    }

    try {
      // Core serialization – includes positions, styles, hierarchy, etc.
      // Note: images (src), event listeners, filters & custom sceneFunc are NOT included
      const jsonString = layer.toJSON(options.space);

      // Create blob and download link
      const blob = new Blob([jsonString], { type: "application/json" });
      const url = URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      link.style.display = "none";

      document.body.appendChild(link);
      link.click();

      // Clean up
      document.body.removeChild(link);
      URL.revokeObjectURL(url);

      console.log(`Stage serialized and download started: ${filename}`);
      return true;
    } catch (err) {
      console.error("Failed to serialize/download Konva layer:", err);
      return false;
    }
  }


}
